import store from '@/store'
import router from '@/router'
import auth from '@/router/middleware/auth';

export default async (to, from, next) => {
    if (!to.meta.middleware || (to.meta.middleware && !to.meta.middleware.length)) {
        if (to.meta.allowAnonymous){
            return next();
        } else {
            return auth({next, store})
        }
    }
    
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = { from, to, next, router, store };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
};

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if(!subsequentMiddleware){
        return context.next;
    }

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}